import { SttUtteranceWithContentAndSpeaker } from '@ftr/contracts/regional-api/stt'
import { startTimeSorter } from '@ftr/foundation'
import { RealTimeSttRemark } from '../types'

/**
 * NOTICE:
 * The start/endTimes are NOT deserialized from the API call, hence the LocalDateTime.parse
 */

export function utterancesToRemarks(utterances: SttUtteranceWithContentAndSpeaker[]): RealTimeSttRemark[] {
  return utterances.map(utteranceToRemark).sort(startTimeSorter)
}

function utteranceToRemark(utterance: SttUtteranceWithContentAndSpeaker): RealTimeSttRemark {
  return {
    id: utterance.id,
    type: 'Remark',
    content: utterance.content,
    speakerId: utterance.sttSpeakerId,
    speakerName: utterance.sttSpeaker.name,
    startTime: utterance.startTime,
    endTime: utterance.endTime,
    dialect: utterance.dialect,
    fragments: utterance.fragments,
  }
}
